import React from 'react';

export default function useWindowResize() {
  const [update, setUpdate] = React.useState(0);
  React.useEffect(() => {
    const forceUpdate = () => setUpdate(u => u + 1);
    window.addEventListener('resize', forceUpdate);
    return () => {
      window.removeEventListener('resize', forceUpdate);
    }
  }, []);
}
